/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsUserControllerBanReasonsViewedMutationResponse,
  TelegramProductsUserControllerBanReasonsViewedPathParams,
  TelegramProductsUserControllerBanReasonsViewed401,
} from '../types/TelegramProductsUserControllerBanReasonsViewed.ts';

function getTelegramProductsUserBanReasonsViewedUrl(
  id: TelegramProductsUserControllerBanReasonsViewedPathParams['id'],
) {
  const res = { method: 'PATCH', url: `/api/user/telegram/products/ban-reasons-viewed/${id}` as const };
  return res;
}

/**
 * {@link /api/user/telegram/products/ban-reasons-viewed/:id}
 */
export async function telegramProductsUserBanReasonsViewed(
  id: TelegramProductsUserControllerBanReasonsViewedPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsUserControllerBanReasonsViewedMutationResponse,
    ResponseErrorConfig<TelegramProductsUserControllerBanReasonsViewed401>,
    unknown
  >({ method: 'PATCH', url: getTelegramProductsUserBanReasonsViewedUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
